import React from 'react'
import Slider from 'react-slick'
import { makeStyles, CircularProgress } from '@material-ui/core'
import UserAvatar from '../shared/UserAvatar'
import gallerySVG from '../../assets/icons/gallery.svg'
import withouItemsFallback from '../../assets/icons/illustration-meditation-relaxed-person.svg'
import StyledSVG from '../shared/StyledSVG'
import moment from 'moment'
import { roles } from '../../utils/constants'

const useStyles = makeStyles(theme => ({
  root: {
    height: 900,
    '& .slick-slide': {
      padding: '10px 0px'
    },
    '& .slick-list': {
      width: '100%',
      margin: '-10px 0px'
    },
    '& .slick-dots': {
      bottom: props => (props.isTeacher ? '-20px' : '-19px'),
      [theme.breakpoints.down('1600')]: {
        bottom: props => (props.isTeacher ? '-19px' : '-19px')
      },
      [theme.breakpoints.down('600')]: {
        bottom: '-30px'
      }
    }
  },
  title: {
    color: '#386093',
    fontSize: 28,
    fontWeight: 600,
    margin: '0px 0px 15px 0px',
    [theme.breakpoints.down('920')]: {
      margin: '20px 0px'
    },
    [theme.breakpoints.down('600')]: {
      textAlign: 'center'
    }
  },
  message: {
    cursor: 'pointer',
    minHeight: props => (props.isTeacher ? 191.4 : 188),
    padding: '16px 24px',
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    [theme.breakpoints.down('1600')]: {
      minHeight: props => (props.isTeacher ? 199 : 188)
    }
  },
  rps_wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 16
  },
  message_overview: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .message-date': {
      color: '#9B9B9B',
      fontSize: 14,
      fontWeight: 500
    }
  },
  message_file_wrapper: {
    marginTop: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ADB8CC26',
    borderRadius: 16
  },
  message_content: {
    fontSize: 14,
    fontWeight: 400,
    color: '#9B9B9B',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
  },
  room_participants: {
    '& p': {
      margin: 0,
      fontSize: 16,
      fontWeight: 500
    }
  },
  fallback_wrapper: {
    height: 820,
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    rowGap: 16,
    '& .description': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& h1': {
        margin: 0,
        color: '#386093',
        fontSize: 24
      },
      '& p': {
        margin: 0,
        fontWeight: 400,
        fontSize: 16,
        textAlign: 'center'
      }
    }
  }
}))

const LastMessagesSlider = ({
  getMessagesWithoutRoomRSPA,
  history,
  currentOccupation,
  fractalId
}) => {
  const isTeacher = currentOccupation?.includes(roles.TEACHER)
  const classes = useStyles({ isTeacher })
  const [lastMessages, setLastMessages] = React.useState({
    items: [],
    isFetching: false
  })
  const [isDragging, setIsDragging] = React.useState(false)
  const defaultParams = { 'page[size]': 20, 'q[message_type_not_eq]': 1 }

  React.useEffect(async () => {
    setLastMessages(prev => ({ ...prev, isFetching: true }))
    getMessagesWithoutRoomRSPA({
      params: {
        ...defaultParams
      },
      currentOccupation,
      fractalId
    }).then(res => {
      setLastMessages(prev => ({ items: res, isFetching: false }))
    })
  }, [])

  const handleClickItem = (e, roomId) => {
    if (isDragging) {
      e.preventDefault()
      e.stopPropagation()
      return
    }
    history.push(`/rooms/${roomId}`)
  }
  if (lastMessages.isFetching) {
    return (
      <div className={classes.fallback_wrapper}>
        <CircularProgress />
      </div>
    )
  }
  return (
    <div className={classes.root}>
      <h1 className={classes.title}>Últimas mensagens</h1>
      {lastMessages.items.length > 0 ? (
        <Slider
          dots
          infinite={false}
          slidesToShow={4}
          slidesToScroll={3}
          vertical
          verticalSwiping
          beforeChange={() => setIsDragging(true)}
          afterChange={() => setIsDragging(false)}
        >
          {lastMessages.items.map(message => {
            const target =
              message.room.room_type === 'group'
                ? message.room.name
                : message.room.participants.find(
                    rp => rp?.user?.fractal_id !== message.user_id
                  )?.user?.name
            return (
              <div
                onClick={event => handleClickItem(event, message.room_id)}
                key={message.id}
                className={classes.message}
              >
                <div className={classes.message_overview}>
                  <div className={classes.rps_wrapper}>
                    <UserAvatar
                      avatarStyle={{ width: 56, height: 56 }}
                      // avatarUrl={message?.user?.avatar_url}
                      userName={message?.user_name}
                      withoutUserName
                    />
                    <div className={classes.room_participants}>
                      <p className='origin'>
                        Enviado por <b>{message?.user_name}</b>
                      </p>
                      <p className='target'>
                        para <b>{target}</b>
                      </p>
                    </div>
                  </div>
                  <p className='message-date'>
                    {moment(message.created_at).format('DD/MM/YYYY')}
                  </p>
                </div>

                {message.content && (
                  <p className={classes.message_content}>{message.content}</p>
                )}
                {message.files_urls.length > 0 && (
                  <div className={classes.message_file_wrapper}>
                    <StyledSVG src={gallerySVG} height={35} width={35} />
                  </div>
                )}
              </div>
            )
          })}
        </Slider>
      ) : (
        <div className={classes.fallback_wrapper}>
          <StyledSVG src={withouItemsFallback} width={330} height={240} />
          <div className='description'>
            <h1>Nenhuma mensagem recente</h1>
            <p>As últimas mensagens recebidas na plataforma aparecerão aqui.</p>
          </div>
        </div>
      )}
    </div>
  )
}

export default LastMessagesSlider
